<script>
	import { onMount, onDestroy } from "svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import FilterForm from "../../../../../components/FilterForm/FilterForm.svelte";
	import PageHeader from "../../../../../components/PageHeader/PageHeader.svelte";
	import SizeSelect from "../../../../../components/SizeSelect/SizeSelect.svelte";
	import client from "../../../../../services/client";
	import MainIssueTable from "./MainIssueTable.svelte";
	import queryString from "query-string";
	import ErrorMessageHandler from "../../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import {
		VehicleReportSectionOptions,
		cmmDamageTypeOptions,
		VehicleCarSectionOptions,
		cmmRejectReasonOptions,
	} from "../../../../../utils/options";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
		initPage,
	} from "../../../../../store/store";
	import { get } from "svelte/store";

	let data = [];

	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	$: queryParams = `?Page=1&Size=${$sizeSelect}`;
	let searchParams = window.location.search.toString();
	let queryPage = searchParams.includes("page");
	let queryPlateNumber = searchParams.includes("vehicleNumber");
	let queryCarSection = searchParams.includes("carSection");
	let queryReportSection = searchParams.includes("reportSection");
	let queryDamageType = searchParams.includes("damageType");

	$: if (queryPage) {
		queryParams = `?Page=${params.page}&Size=${$sizeSelect}`;
	}
	$: if (queryPlateNumber) {
		queryParams = queryParams.concat(
			`&PlateNumber=${params.vehicleNumber}`
		);
	}

	$: if (queryCarSection) {
		queryParams = queryParams.concat(
			`&CarSection=${String(
				VehicleCarSectionOptions.findIndex(
					(x) => x.label === params.carSection
				)
			)}`
		);
	}

	$: if (queryReportSection) {
		queryParams = queryParams.concat(
			`&ReportSection=${String(
				VehicleReportSectionOptions.findIndex(
					(x) => x.label === params.reportSection
				)
			)}`
		);
	}

	$: if (queryDamageType) {
		queryParams = queryParams.concat(
			`&DamageType=${String(
				cmmDamageTypeOptions.findIndex(
					(x) => x.label === params.damageType
				)
			)}`
		);
	}

	const query = queryString.parse(window.location.search);
	onMount(async () => {
		document.body.scrollIntoView();
		try {
			loading.set(true);
			const res = await client(`/v0/cmm/rejected-issue${queryParams}`, {
				method: "GET",
				version: "Tasking",
			});
			data = res.data.data;

			totalPages.set(res.data.totalPage);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);

			console.log(err.response);
			errorMessage.set(err.response.data.errors[""]["0"]);
		}
	});
	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	const trigerSelectIssue = async (limit) => {
		try {
			loading.set(true);
			const res = await client(`/v0/cmm/rejected-issue${queryParams}`, {
				method: "GET",
				version: "Tasking",
			});
			data = res.data.data;

			totalPages.set(res.data.totalPage);

			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);

			console.log(err.response);
			errorMessage.set(err.response.data.errors[""]["0"]);
		}
	};

	const handleStatus = async (issueId) => {
		try {
			loading.set(true);

			const res = await client(`/v0/Issue/v2/Reopen`, {
				method: "POST",
				version: "Tasking",
				data: { issueId },
			});

			trigerSelectIssue();
			loading.set(false);
			window.location.reload();
		} catch (error) {
			loading.set(false);
			console.log(error.response);
		}
	};

	onDestroy(() => {
		initPage.set(1);
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Rejected Issues" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm
						carSection
						reportSection
						damageType
						vehicleNumber
						reportStatus,
						rejectReason
					/>
				</Col>
				<Col class="d-flex justify-content-end" xs={6}>
					<div class="d-flex align-items-center">
						<SizeSelect trigerSelect={trigerSelectIssue} />
					</div>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<MainIssueTable {data} {handleStatus} />
	</Col>
</Row>
